export default __webpack_public_path__ + "static/media/mz.8a266b26.gif";